/**
 * Mock Aruba onboarding — 5 steps the legacy template walks through.
 */
import type { ArubaOnboardingStep } from "@/api/schemas/aruba";

export const MOCK_ARUBA_ONBOARDING: ArubaOnboardingStep[] = [
  { slug: "key-active",      title: "Active Aruba key",                state: "ok",      detail: "client_id •••• 8c90 (Greenlake prod)" },
  { slug: "group-baseline",  title: "Group baseline applied",          state: "ok",      detail: "GuestTek-2024 baseline · all 3 groups compliant" },
  { slug: "rdv-clean",       title: "RDV queue clear for site",        state: "running", detail: "validating 3 devices…" },
  { slug: "compliance-scan", title: "Compliance scan",                 state: "pending", detail: "queued behind RDV" },
  { slug: "monitoring-bind", title: "Bound to monitoring (Halo + Synapse)", state: "pending", detail: "" },
];
